export class NextQueueItem<T> {
  constructor(public item: T, public wasProcessing: boolean = true) {}
}
